import { ACCESS_RULE_LABELS, type AccessInfo, type AccessRule } from '@creativitas/shared';

/**
 * Turns an access verdict into the two lines the locked-state UI shows (§19):
 * the primary route, and the alternatives when there is more than one.
 */

const RULE_ROUTE: Record<AccessRule, string | null> = {
  free: null,
  trial: 'в пробном периоде',
  light: 'в тарифе Лайт',
  pro: 'в тарифе Про',
  game_owner: 'владельцам игры',
  manual: 'по доступу от администратора',
};

export type LockedCopy = { reason: string; hint: string | null };

export function lockedCopy(access: AccessInfo): LockedCopy | null {
  if (access.allowed) return null;

  const routes = access.declaredRules
    .map((rule) => RULE_ROUTE[rule])
    .filter((route): route is string => route !== null);

  // The denial message already names one route; mention the others only when
  // they genuinely give the user a second way in.
  const hint =
    routes.length > 1 ? `Открывается ${routes.join(' или ')}.` : null;

  return { reason: access.message, hint };
}

/** Short badges listing the declared rules, for admin and catalogue views. */
export const ruleLabels = (rules: AccessRule[]): string[] =>
  rules.map((rule) => ACCESS_RULE_LABELS[rule]);
